import _ from 'lodash';
import React from 'react';

const defaultCurrentEditingCompany = {
  name: '',
  administratorEmail: '',
  websiteUrl: '',
  summary: '',
  members: [],
};

const removeMember = (state, memberId) => {
  const cec = state.currentEditingCompany;
  return {
    ...state,
    currentEditingCompany: {
      ...cec,
      // _.filter returns a new array, and does not mutate old array
      members: _.filter(cec.members, m => m.id !== memberId),
    },
  };
};

const addMember = (state, newMember) => ({
  ...state,
  currentEditingCompany: {
    ...state.currentEditingCompany,
    members: [...state.currentEditingCompany.members, newMember],
  },
});

const updateCompany = (state, company) => ({
  ...state,
  companies: state.companies.map(c => (c.id === company.id ? company : c)),
});

const reducer = (state, { type, payload }) => {
  switch (type) {
    case 'setCompanies':
      return { ...state, companies: payload };
    case 'editCompany':
      return {
        ...state,
        currentEditingCompany: payload,
        showEditModal: true,
        showBrandModal: false,
        showCompanyCTAModal: false,
        showContributorCTAModal: false,
      };
    case 'brandCompany':
      return {
        ...state,
        currentEditingCompany: payload,
        showBrandModal: true,
        showEditModal: false,
        showCompanyCTAModal: false,
        showContributorCTAModal: false,
      };
    case 'ctaCompany':
      return {
        ...state,
        currentEditingCTAOwner: payload,
        showCompanyCTAModal: true,
        showContributorCTAModal: false,
        showEditModal: false,
        showBrandModal: false,
      };
    case 'ctaContributor':
      return {
        ...state,
        currentEditingCTAOwner: payload,
        showCompanyCTAModal: false,
        showContributorCTAModal: true,
        showEditModal: false,
        showBrandModal: false,
      };
    case 'dismissModal':
      return {
        ...state,
        currentEditingCompany: defaultCurrentEditingCompany,
        currentEditingCTAOwner: {},
        showEditModal: false,
        showBrandModal: false,
        showCompanyCTAModal: false,
        showContributorCTAModal: false,
      };
    case 'companyCreated':
      return { ...state, companies: [...state.companies, payload] };
    case 'companyUpdated':
      return updateCompany(state, payload);
    case 'addMember':
      return addMember(state, payload);
    case 'removeMember':
      return removeMember(state, payload.id);
    default:
      throw new Error();
  }
};

const defaultState = {
  companies: [],
  showEditModal: false,
  showBrandModal: false,
  showCompanyCTAModal: false,
  showContributorCTAModal: false,
  currentEditingCompany: defaultCurrentEditingCompany,
  currentEditingCTAOwner: {},
};

const CompaniesContext = React.createContext();

export default CompaniesContext;
export {
  defaultState,
  reducer,
};
